import React, { Component } from 'react';
// import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { Col, Alert } from 'reactstrap';
import { Modal } from 'antd';
// Local Deps
import './EditToolingManagement.scss';
import ToolingManagementDefinitionForm from '../../forms/ToolingManagementDefinitionForm';
import EditToolingManagementHOC from './EditToolingManagementHOC';

class EditToolingManagement extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    formValues: PropTypes.object.isRequired,
    handleInitalValueReset: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    showEditModal: PropTypes.bool.isRequired,
    closeEditModal: PropTypes.func.isRequired,
  };

  static initialState = {};

  state = EditToolingManagement.initialState;

  render() {
    const { onSubmit, formValues, type, message, handleInitalValueReset, closeEditModal } = this.props;
    return (
      <Modal
        title={<h3>Edit Tooling Management</h3>}
        visible={this.props.showEditModal}
        width="fit-content"
        footer={null}
        onCancel={this.props.closeEditModal}
      >
        <Col style={{ display: 'flex', justifyContent: 'center' }}>
          {message && <Alert color={type}>{message}</Alert>}
        </Col>
        {/* <Row> */}
        {/* <!-- FORM --> */}
        <div className="nf-edit-tool__form">
          <ToolingManagementDefinitionForm
            onSubmit={onSubmit}
            initialValues={formValues}
            handleInitalValueReset={handleInitalValueReset}
            closeEditModal={closeEditModal}
          />
        </div>
        {/* </Row> */}
      </Modal>
    );
  }
}

export default EditToolingManagementHOC(EditToolingManagement);



// WEBPACK FOOTER //
// ./src/components/Modals/EditToolingManagement/EditToolingManagement.jsx